import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=6261fc7b&scoped=true&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=6261fc7b&lang=scss&scoped=true&"
import style1 from "./GlobalSearch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6261fc7b",
  null
  
)

export default component.exports